var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 1.66666H5.83317C3.53198 1.66666 1.6665 3.53214 1.6665 5.83333V14.1667C1.6665 16.4678 3.53198 18.3333 5.83317 18.3333H14.1665C16.4677 18.3333 18.3332 16.4678 18.3332 14.1667V5.83333C18.3332 3.53214 16.4677 1.66666 14.1665 1.66666Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.475C13.4361 10.1685 13.3176 10.8768 12.9947 11.4992C12.6718 12.1215 12.1609 12.6262 11.5346 12.9414C10.9083 13.2566 10.1986 13.3663 9.50641 13.2549C8.81419 13.1436 8.17472 12.8167 7.67895 12.321C7.18318 11.8252 6.85636 11.1857 6.74497 10.4935C6.63359 9.80129 6.74331 9.09158 7.05852 8.46531C7.37374 7.83904 7.87841 7.32812 8.50074 7.0052C9.12307 6.68228 9.83138 6.56382 10.5249 6.66667C11.2324 6.77157 11.8873 7.10122 12.393 7.60692C12.8987 8.11262 13.2283 8.76756 13.3333 9.475Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 5.41666H14.5935",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3515c1be558375d1055570e5a95d279f.svg";
export { ForwardRef as ReactComponent };